import { computed, inject, Injectable, signal } from "@angular/core";
import { s25Resource } from "../../../util/s25.resource";
import { ElectionApi, type ElectionHeader } from "./election.api";
import { LoginStore } from "../../../stores/login.store";

/**
 * Eligible-to-vote elections for the Connect25 top nav; call {@link #refresh} after ballot submit.
 */
@Injectable({ providedIn: "root" })
export class ElectionEligibleStore {
    private readonly loginStore = inject(LoginStore);
    private readonly loadGeneration = signal(0);

    private readonly resource = s25Resource({
        if: () => this.loginStore.loggedIn() && this.loginStore.init(),
        params: () => this.loadGeneration(),
        loader: async (): Promise<ElectionHeader[]> => (await ElectionApi.getEligible()) ?? [],
    });

    /** Current eligible elections (empty when not logged in / still loading). */
    readonly elections = computed(() => this.resource.value() ?? []);

    async refresh(): Promise<void> {
        this.loadGeneration.update((n) => n + 1);
    }
}
